<template>
  <div class="narrow-container mx-2">
    <div
      class="d-flex flex-row align-center justify-space-between pa-0 px-4 mt-4 w-full"
    >
      <v-text-field
        v-model.lazy="search"
        filled
        dark
        dense
        hide-details
        prepend-inner-icon="search"
        placeholder="Search Report"
        class="pa-0 flex-grow-0 search-input w-full"
        :disabled="loading"
      />
    </div>
    <div class="TheReport">
      <report-card
        v-for="report in filteredReports"
        :title="report.title"
        :lastUpdate="report.lastUpdate"
        :route="report.route"
        :key="report.title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { size, orderBy, slice } from 'lodash'
import moment from 'moment'

import { guid } from '@/utils/common'
import marketplaceAPI from '@/services/marketplace'

import ReportCard from './ReportCard'
export const MODE_GALLERY = 'MODE_GALLERY'
export const MODE_LIST = 'MODE_LIST'

export default {
  name: 'TheReport',
  components: {
    ReportCard,
  },
  data() {
    return {
      list: [
        // Only include reports that are available via the new marketplace API
        { title: 'Top Developers', route: 'report_top_developers', reportType: 'top_developers' },
        { title: 'Plugin Installs', route: 'report_plugin_installs', reportType: 'plugin_installs' },
      ],
      search: '',
      loading: false,
      reportGenerations: {},
    }
  },
  computed: {
    ...mapState({
      projects: (state) => state.projects.list,
      sites: ({ sites }) => sites.list,
    }),
    productionSites() {
      return this.sites.filter((s) => s.mode == 'production')
    },
    getRecentSites() {
      const sevenDaysBefore = moment().subtract(7, 'days')
      const sortedSites = orderBy(this.productionSites, ['updatedAt'], 'desc')
      const filteredSites = sortedSites.filter(
        (site) => moment(site.updatedAt) > sevenDaysBefore
      )
      if (size(filteredSites) > 4) {
        return slice(filteredSites, 0, 4)
      }
      return filteredSites
    },
    reportsWithLastUpdate() {
      return this.list.map((report) => {
        const generation = this.reportGenerations[report.reportType]
        let lastUpdate = null

        if (generation && generation.generated_at) {
          const date = moment(generation.generated_at)
          if (date.isValid()) {
            lastUpdate = date.fromNow()
          }
        }

        return {
          ...report,
          lastUpdate,
        }
      })
    },
    filteredReports() {
      if (!this.search) {
        return this.reportsWithLastUpdate
      }
      const searchLower = this.search.toLowerCase()
      return this.reportsWithLastUpdate.filter((report) =>
        report.title.toLowerCase().includes(searchLower)
      )
    },
  },
  async mounted() {
    await this.fetchLatestReportGenerations()
  },
  methods: {
    /**
     * Fetch the latest report generation for each report type
     */
    async fetchLatestReportGenerations() {
      try {
        // Fetch latest completed report generations for each report type
        const reportTypes = this.list
          .map((r) => r.reportType)
          .filter((type) => type !== null)

        for (const reportType of reportTypes) {
          try {
            const response = await marketplaceAPI.listReportGenerations({
              report_type: reportType,
              status: 'completed',
              per_page: 1,
              page: 1,
            })

            if (
              response &&
              response.report_generations &&
              response.report_generations.length > 0
            ) {
              this.reportGenerations[reportType] =
                response.report_generations[0]
            }
          } catch (error) {
            console.warn(
              `Failed to fetch report generation for ${reportType}:`,
              error
            )
            // Continue with other report types
          }
        }
      } catch (error) {
        console.warn('Failed to fetch report generations:', error)
        // Don't block the UI if this fails
      }
    },
    createSite() {
      if (!this.name) return

      const siteData = {
        url: this.name,
      }
      this.$store
        .dispatch('sites/create', siteData)
        .then((res) => {
          this.errorMain = ''
          this.$router.push('/site/' + res.id)
        })
        .catch((error) => {
          if (!error) return

          let errorMain = ''
          error.body.errors.url.forEach((message) => {
            errorMain = errorMain + message + '. '
          })
          this.errorMain = errorMain.substr(0, errorMain.length - 4) + '.'
        })
    },
    createProject() {
      if (!this.name) return

      const projectData = {
        id: guid(),
        name: this.name,
      }
      this.$store.dispatch('projects/create', projectData)
    },
  },
}
</script>
<style lang="scss">
$style: TheReport;
.#{$style} {
  padding: 42px 24px 24px;
  &__row {
    margin-bottom: 58px;
  }
}
.w-full {
  width: 100%;
}
</style>
